// extracted by mini-css-extract-plugin
export default {"inputPlaceholder":"FormikDateInput_inputPlaceholder__t5EK9","clearButton":"FormikDateInput_clearButton__DQini"};